import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { backend_url } from "../../App";
import { FiArrowRight } from "react-icons/fi";
import HeaderTitle from "../HederTitle/HeaderTitle";

const Category = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => { fetchCategories(); }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/browsecategory`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  return (
    <section className="relative py-14 px-6 sm:px-12 overflow-hidden bg-white">

      {/* Soft purple tint blobs */}
      <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full blur-3xl opacity-30 pointer-events-none"
        style={{ background: "radial-gradient(circle,#EEE5FA,transparent)" }} />
      <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{ background: "radial-gradient(circle,#F6F1FE,transparent)" }} />

      <div className="relative max-w-7xl mx-auto">

        {/* Header — shared serif style */}
        <div className="mb-8">
          <HeaderTitle Header="Browse by Category" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-3 xs:grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-7 gap-x-4 gap-y-8 justify-items-center">

          {categories.map((category, index) => (
            <Link
              key={category._id}
              to={`collections/${category.routeTo}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group cursor-pointer flex flex-col items-center text-center w-full max-w-[180px]"
            >
              {/* Swatch */}
              <div className="relative rounded-full overflow-hidden transition-all duration-400 shrink-0
                               w-20 h-20 xs:w-24 xs:h-24 sm:w-28 sm:h-28 lg:w-36 lg:h-36"
                style={{
                  boxShadow: "0 2px 16px rgba(124,58,237,0.10)",
                  border: "3px solid #EEE5FA",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.boxShadow = "0 10px 30px rgba(124,58,237,0.25)";
                  e.currentTarget.style.border = "3px solid #9E79D2";
                  e.currentTarget.style.transform = "translateY(-4px)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.boxShadow = "0 2px 16px rgba(124,58,237,0.10)";
                  e.currentTarget.style.border = "3px solid #EEE5FA";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <img
                  loading="lazy"
                  crossOrigin="anonymous"
                  src={`${category.image}`}
                  alt={category.collectionName}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                />
              </div>

              {/* Label */}
              <p className="mt-4 font-bold text-base leading-tight text-gray-900 line-clamp-2">
                {category.collectionName}
              </p>
              <p className="text-xs font-medium mt-0.5 flex items-center gap-1"
                style={{ color: "#8353C6" }}>
                Explore
                <FiArrowRight size={12} className="transition-transform duration-300 group-hover:translate-x-1" />
              </p>
            </Link>
          ))}

          <div className="shrink-0 w-2" />
        </div>
      </div>
    </section>
  );
};

export default Category;
